{
  "en": {
    "brand": {
      "name": "kreditiem.lv | Apdrošināšana",
      "legal_name": "AS Baltijas investīciju un attīstības fonds",
      "tagline": "Insurance in partnership with Balcia Insurance",
      "broker_label": "Balcia Insurance partner",
      "description": "Insurance in partnership with Balcia Insurance. We help private clients and businesses choose and arrange suitable cover.",
      "email": "info@kreditiem.lv",
      "phone": "+371 20865183",
      "phone_e164": "+37120865183",
      "working_hours": "Monday–Friday: 8:00–18:00",
      "address": "Bukultu iela 11, Riga, Latvia",
      "street_address": "Bukultu iela 11",
      "postal_code": "LV-1024",
      "address_locality": "Riga",
      "address_country": "LV",
      "registration_number": 40003000000,
      "opening_hours": "Mo-Fr 08:00-18:00"
    },
    "form": {
      "other_slug": "other",
      "other_label": "Other",
      "insurance_types": {
        "octa": "MTPL (OCTA)",
        "kasko": "Casco",
        "home": "Home",
        "travel": "Travel",
        "health": "Health",
        "accident": "Accident",
        "liability": "Liability",
        "employee": "Employees",
        "commercial_real_estate": "Commercial property",
        "Freight": "Cargo",
        "company": "Business",
        "other": "Other"
      }
    },
    "breadcrumbs": {
      "home": "Home",
      "blog": "Blog",
      "private_persons": "Private clients",
      "businesses": "Business"
    },
    "cookie_consent": {
      "accept": "Accept All",
      "decline": "Decline",
      "message": "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
      "privacy_policy": "Read our Privacy Policy",
      "settings": "Cookie settings"
    },
    "insurance_products": {
      "show": {
        "private_breadcrumb": "Private clients",
        "business_breadcrumb": "Business"
      }
    },
    "meta": {
      "home": {
        "title": "%{brand} — %{tagline}",
        "description": "%{description}"
      },
      "private_persons": {
        "title": "Insurance for private clients — MTPL, casco, home, travel | %{brand}",
        "description": "Insurance offer for private clients: MTPL, casco, home, travel, health and accident cover."
      },
      "businesses": {
        "title": "Business insurance — property, liability, employees, cargo | %{brand}",
        "description": "Insurance for companies: commercial property, liability, employee health, cargo and transport cover."
      },
      "blogs": {
        "title": "Insurance blog — guides and explanations | %{brand}",
        "description": "Articles on insurance: how to choose MTPL and casco, what home insurance covers, how to claim, and advice for businesses."
      },
      "blog_category": {
        "title": "%{name} — articles and advice | %{brand}"
      },
      "application": {
        "title": "Apply for insurance — get an offer | %{brand}",
        "description": "Fill in one application and receive an insurance offer. Free advice for private clients and businesses."
      },
      "contacts": {
        "title": "Contacts — get in touch with an insurance consultant | %{brand}",
        "description": "Contact %{brand}: %{phone}, %{email}. %{working_hours}."
      },
      "not_found": {
        "title": "Page not found | %{brand}",
        "description": "This page could not be found. Return to the homepage or contact us."
      }
    },
    "home": {
      "hero": {
        "title": "Get an insurance offer",
        "subtitle": "Fill in one application and our insurance consultant will prepare an offer. Advice is free — you decide whether to buy.",
        "highlights": [
          "One application — one offer",
          "Free consultation with an insurance consultant",
          "Reply within one working day"
        ],
        "stats": [
          {
            "value": "Balcia",
            "label": "Insurance partner"
          },
          {
            "value": "4 min",
            "label": "Average time to complete an application"
          },
          {
            "value": "9 000+",
            "label": "Offers prepared"
          }
        ]
      },
      "advantages": [
        {
          "icon": "layers",
          "title": "An offer in one application",
          "description": "Fill in the application and we will prepare an insurance offer that fits your situation."
        },
        {
          "icon": "bolt",
          "title": "Fast review of your application",
          "description": "Filling in the form takes a few minutes, and we usually prepare an offer within one working day."
        },
        {
          "icon": "gift",
          "title": "Free consultation",
          "description": "You do not pay for the consultation. We explain the terms in plain language, including the small print."
        },
        {
          "icon": "user-check",
          "title": "A dedicated insurance consultant",
          "description": "You have one contact — both when choosing a policy and later if you need to make a claim."
        }
      ],
      "steps": [
        {
          "title": "Fill in the application",
          "description": "Tell us what you want to insure and how to reach you. You can leave the detailed questions to our consultant."
        },
        {
          "title": "Our consultant prepares an offer",
          "description": "We check that the cover fits your situation and prepare an insurance offer."
        },
        {
          "title": "Receive the offer",
          "description": "We send the offer with the price and cover. Once you choose, we arrange the policy remotely."
        }
      ],
      "testimonials": [
        {
          "name": "Ilze K.",
          "role": "Riga, home insurance",
          "quote": "The consultant explained what the policy covers. I chose the offer that included water leakage.",
          "rating": 5
        },
        {
          "name": "Māris B.",
          "role": "Jelgava, MTPL and casco",
          "quote": "I used to buy MTPL at the last minute without thinking. This time I received a clear offer and arranged the policy in time.",
          "rating": 5
        },
        {
          "name": "Anete S.",
          "role": "Company director, employee insurance",
          "quote": "We needed health insurance for 14 employees. The consultant prepared an offer I could show the board.",
          "rating": 5
        }
      ],
      "faq": [
        {
          "question": "How much does the consultation cost?",
          "answer": "Preparing the application and the consultation cost you nothing. Our consultant is paid by the insurer, so the policy price is not higher than buying directly."
        },
        {
          "question": "How quickly will I receive an offer?",
          "answer": "For simple products such as MTPL or travel insurance we usually send a quote within a few hours on a working day. Business insurance can take two to three working days."
        },
        {
          "question": "Do I have to accept an offer?",
          "answer": "No. The offer is informational and you have no obligation to take it. If it does not fit, we can clarify your needs or stop contacting you."
        },
        {
          "question": "What data do you store?",
          "answer": "We store only the information needed to prepare an offer and share it with the insurer. You can ask us to delete the data at any time."
        },
        {
          "question": "Can you help after a claim has happened?",
          "answer": "Yes. We help you understand which documents are needed and contact the insurer if the claims process is taking too long."
        },
        {
          "question": "Can I insure several things in one application?",
          "answer": "Choose the main insurance type in the form and mention the rest in the comments. Our consultant will prepare a combined quote, which often includes a discount for several products."
        }
      ],
      "sections": {
        "products": {
          "eyebrow": "Insurance types",
          "title": "Choose what you want to insure",
          "subtitle": "Each type has its own page where we explain cover, exclusions and how the price is formed."
        },
        "advantages": {
          "eyebrow": "Why us",
          "title": "Our consultant works in your interest, not the insurer’s"
        },
        "steps": {
          "eyebrow": "How it works",
          "title": "Three steps to a quote"
        },
        "faq": {
          "eyebrow": "Common questions",
          "title": "Answers to what clients ask most often"
        },
        "blog": {
          "eyebrow": "Blog",
          "title": "Useful articles about insurance"
        }
      }
    },
    "contacts": {
      "intro": "Write or call — we reply on working days. If you want a quote, the fastest way is to fill in the application so we can see the details we need.",
      "channels": [
        {
          "icon": "phone",
          "label": "Phone",
          "value": "+371 20865183",
          "href": "tel:+37120865183",
          "note": "Monday–Friday: 8:00–18:00"
        },
        {
          "icon": "mail",
          "label": "Email",
          "value": "info@kreditiem.lv",
          "href": "mailto:info@kreditiem.lv",
          "note": "We reply within 1 working day"
        },
        {
          "icon": "map-pin",
          "label": "Office",
          "value": "Bukultu iela 11, Riga, Latvia",
          "note": "Meetings by appointment"
        }
      ],
      "notes": [
        {
          "title": "Reviewing applications",
          "description": "We receive applications around the clock, but process them during working hours. In urgent cases — for example if your MTPL expires today — please call."
        },
        {
          "title": "Claims questions",
          "description": "If an insured event has happened, report it to the insurer first and then to us — we will help with documents and communication."
        }
      ],
      "page": {
        "title": "Contact us",
        "channels_title": "Ways to get in touch",
        "notes_title": "Good to know",
        "details_title": "Company details",
        "name": "Name",
        "registration_number": "Registration number",
        "address": "Address",
        "working_hours": "Working hours",
        "cta_title": "Want a quote without a call?",
        "cta_description": "Fill in the application and we will reply with an insurance offer."
      }
    },
    "audiences": {
      "private": {
        "heading": "Insurance for private clients",
        "subheading": "Choose an insurance type and receive an offer in one application."
      },
      "business": {
        "heading": "Insurance for businesses",
        "subheading": "From commercial property to employee health — we will prepare an offer that matches the risks in your industry."
      },
      "sections": {
        "products_private": "Insurance types for private clients",
        "products_business": "Insurance types for businesses",
        "products_subtitle": "Each page covers the policy, exclusions, indicative prices and frequent questions.",
        "steps_title": "How to apply",
        "advantages_title": "What you gain by working with a consultant",
        "faq_title": "Common questions"
      }
    },
    "categories": {
      "auto": {
        "name": "Motor insurance",
        "description": "MTPL, casco and everything you need to know about car insurance in Latvia.",
        "position": 1
      },
      "majoklis": {
        "name": "Home insurance",
        "description": "House, apartment and household contents insurance explained in plain language.",
        "position": 2
      },
      "celojumi": {
        "name": "Travel insurance",
        "description": "What a travel policy covers, what to do abroad and how to choose the right cover.",
        "position": 3
      },
      "veseliba": {
        "name": "Health insurance",
        "description": "Health and accident insurance for individuals and families.",
        "position": 4
      },
      "uznemumiem": {
        "name": "Business insurance",
        "description": "Risk management for companies: property, interruption, employees and cargo.",
        "position": 5
      },
      "atbildiba": {
        "name": "Liability insurance",
        "description": "When liability cover is compulsory and when it is simply wise.",
        "position": 6
      },
      "atlidzibas": {
        "name": "Claims",
        "description": "How to file a claim, which documents you need and why claims are declined.",
        "position": 7
      },
      "padomi": {
        "name": "Insurance tips",
        "description": "Practical advice on choosing cover and not paying for extras you do not need.",
        "position": 8
      }
    },
    "category_order": [
      "auto",
      "majoklis",
      "celojumi",
      "veseliba",
      "uznemumiem",
      "atbildiba",
      "atlidzibas",
      "padomi"
    ],
    "product_order": [
      "octa",
      "kasko",
      "majokla-apdrosinasana",
      "celojumu-apdrosinasana",
      "veselibas-apdrosinasana",
      "nelaimes-gadijumu-apdrosinasana",
      "civiltiesiska-atbildiba",
      "darbinieku-apdrosinasana",
      "komercipasuma-apdrosinasana",
      "kravu-apdrosinasana",
      "uznemumu-apdrosinasana"
    ],
    "blog_order": [
      "pasrisks-ka-izveleties",
      "ka-ietaupit-uz-apdrosinasanu",
      "kapec-atsaka-atlidzibu",
      "ka-pieteikt-atlidzibu",
      "kravu-apdrosinasana-vai-pietiek-ar-parvadataju",
      "komercipasuma-apdrosinasana-noliktavai",
      "uznemuma-apdrosinasana-ar-ko-sakt",
      "profesionala-atbildiba-pakalpojumiem",
      "civiltiesiska-atbildiba-uznemumiem",
      "nelaimes-gadijumu-apdrosinasana-berniem",
      "veselibas-polise-ko-tiesi-sedz",
      "veselibas-apdrosinasana-darbiniekiem",
      "celojumu-apdrosinasana-ziemas-sportam",
      "evak-karte-vai-celojumu-polise",
      "celojumu-apdrosinasana-eiropa",
      "ka-noteikt-apdrosinajuma-summu",
      "udens-noplude-dzivokli",
      "ko-sedz-majokla-apdrosinasana",
      "bonus-malus-sistema",
      "kasko-vai-octa",
      "ka-izveleties-octa"
    ],
    "page_order": [
      "lietosanas-noteikumi",
      "privatuma-politika",
      "sikdatnu-politika"
    ],
    "products": {
      "octa": {
        "name": "MTPL (OCTA)",
        "short_name": "OCTA",
        "tagline": "Compulsory motor third party liability insurance",
        "summary": "The statutory policy that covers damage you cause to others with a vehicle. Driving in Latvia without it is not allowed."
      },
      "kasko": {
        "name": "Casco",
        "short_name": "Casco",
        "tagline": "Voluntary motor insurance",
        "summary": "Covers damage to your own car — in a collision, theft, fire or natural disaster. You choose the cover and deductible."
      },
      "majokla-apdrosinasana": {
        "name": "Home insurance",
        "short_name": "Home",
        "tagline": "Protection for apartments and private houses",
        "summary": "Covers the structure, interior finishes and household contents of an apartment or house — from water leaks to storms and fire."
      },
      "celojumu-apdrosinasana": {
        "name": "Travel insurance",
        "short_name": "Travel",
        "tagline": "Medical assistance and travel risks abroad",
        "summary": "Covers emergency medical care abroad, lost luggage and trip cancellation. A single-trip policy or an annual policy."
      },
      "veselibas-apdrosinasana": {
        "name": "Health insurance",
        "short_name": "Health",
        "tagline": "Faster access to doctors and examinations",
        "summary": "Covers GP and specialist visits, examinations, dentistry and medicines according to the chosen programme."
      },
      "nelaimes-gadijumu-apdrosinasana": {
        "name": "Accident insurance",
        "short_name": "Accident",
        "tagline": "A cash benefit in case of injury or inability to work",
        "summary": "Pays a fixed sum if you are injured, unable to work or become disabled. Valid 24 hours a day, including leisure and sport."
      },
      "civiltiesiska-atbildiba": {
        "name": "Liability insurance",
        "short_name": "Liability",
        "tagline": "Covers damage you cause to others",
        "summary": "Compensates third parties for material and personal damage, including legal costs, if a claim is brought against you."
      },
      "darbinieku-apdrosinasana": {
        "name": "Employee insurance",
        "short_name": "Employees",
        "tagline": "Health and accident cover for a team",
        "summary": "An employee benefits package: health insurance, accidents and life cover with tax relief within the statutory limits."
      },
      "komercipasuma-apdrosinasana": {
        "name": "Commercial property insurance",
        "short_name": "Commercial property",
        "tagline": "Offices, plants, warehouses and retail space",
        "summary": "Covers commercial buildings, fit-out, equipment and stock, as well as lost profit if operations have to stop for a time."
      },
      "kravu-apdrosinasana": {
        "name": "Cargo insurance",
        "short_name": "Cargo",
        "tagline": "Protection of goods in transit",
        "summary": "Covers cargo damage, theft and loss during road, sea, air or rail transport — regardless of the carrier’s liability limits."
      },
      "uznemumu-apdrosinasana": {
        "name": "Business insurance",
        "short_name": "Business",
        "tagline": "A combined solution for company risks",
        "summary": "One contract combining property, liability, employees and business interruption. Suited to SMEs that do not want several separate policies."
      }
    },
    "ui": {
      "skip_to_content": "Skip to content",
      "optional": "optional",
      "locales": {
        "lv": "Latviešu",
        "en": "English",
        "ru": "Русский"
      },
      "locale_switcher": {
        "label": "Language"
      },
      "nav": {
        "main": "Main navigation",
        "mobile": "Mobile navigation",
        "open": "Open menu",
        "close": "Close menu",
        "private": "Private clients",
        "business": "Business",
        "blog": "Blog",
        "contacts": "Contacts",
        "financing": "Financing",
        "apply": "Apply"
      },
      "logo": {
        "home": "%{brand} — homepage",
        "descriptor": "insurance"
      },
      "footer": {
        "private": "Private clients",
        "business": "Business",
        "blog": "Blog",
        "legal": "Legal information",
        "copyright": "© %{year} %{name}. All rights reserved.",
        "disclaimer": "Scope of authority — partnership with Balcia Insurance. The insurance contract is concluded with the insurance company.",
        "privacy": "Privacy policy",
        "cookies": "Cookie policy",
        "terms": "Terms of use"
      },
      "cta": {
        "apply": "Apply",
        "learn_more": "Learn more",
        "get_offer": "Get a quote",
        "all_posts": "All articles",
        "title": "Get an insurance quote",
        "description": "Fill in the application in a few minutes and our consultant will prepare an insurance offer. Consultation is free.",
        "call": "Call %{phone}"
      },
      "home": {
        "all_posts": "All articles",
        "apply": "Apply",
        "learn_more": "Learn more",
        "step": "Step %{n}."
      },
      "product": {
        "benefits_title": "What %{name} insurance gives you",
        "coverage_title": "What is and is not covered",
        "covered": "Usually covered",
        "not_covered": "Usually not covered",
        "coverage_note": "The exact cover is set by the insurer’s policy wording, which you receive before purchase.",
        "pricing_title": "How much it costs",
        "price_factors": "What affects the price",
        "faq_title": "Common questions",
        "related": "People also choose",
        "cta_title": "Get a %{name} quote",
        "get_offer": "Get a quote"
      },
      "blog": {
        "title": "Insurance blog",
        "subtitle": "Explanations and tips that help you choose the right cover and avoid paying for extras.",
        "all_posts": "All articles",
        "categories": "Blog categories",
        "empty": "There are no articles in this category yet. See",
        "empty_link": "all articles",
        "reading_time": "%{count} min read",
        "article": "Article",
        "topics": "Topics",
        "related_offer_title": "Want a quote for %{name}?",
        "about_product": "About %{name}",
        "get_offer": "Get a quote",
        "disclaimer": "This article is informational and does not replace the insurance contract. If you have questions, %{link}.",
        "contact_us": "contact us",
        "related_posts": "Other articles in this category"
      },
      "static": {
        "updated": "Updated:"
      },
      "not_found": {
        "title": "Page not found",
        "body": "The link may be out of date or the address may contain a typo. Start from the homepage or fill in an application — we will get in touch.",
        "home": "Back to homepage",
        "apply": "Apply for insurance",
        "or_call": "Or call:"
      },
      "error": {
        "title": "This page could not be shown",
        "body": "The error is on our side. Reload the page or contact us — we can also take applications by phone.",
        "reload": "Reload page",
        "contacts": "Contacts"
      },
      "application": {
        "title": "Application for an insurance quote",
        "subtitle": "It takes about 3 minutes. The application is not binding.",
        "hero_title": "Apply now",
        "how_we_work": "How we work",
        "need_help": "Need help filling this in?",
        "disclaimer": "Submitting an application does not buy a policy — you first receive an offer to review.",
        "success_title": "Application received",
        "success_body": "Our consultant will review your needs and contact you within one working day — by phone or by writing to %{email}.",
        "reference": "Application number:",
        "home": "Back to homepage",
        "read_blog": "Read the blog",
        "next": "Next",
        "back": "Back",
        "submit": "Get an insurance quote",
        "submit_hero": "Get a quote",
        "submitting": "Sending…",
        "call_also": "You can also call: %{phone}.",
        "submit_error": "Could not send the application",
        "step_of": "Step %{current} of %{total}",
        "step_aria": "Application step %{current} of %{total}",
        "validation_error": "There are errors in the application",
        "rate_limit": "Too many requests. Please try later or call us.",
        "server_error": "Could not reach the server. Please try again.",
        "trust": [
          "We prepare an insurance offer",
          "Consultation and application prep are free",
          "We reply within one working day",
          "We use your data only to prepare a quote"
        ],
        "steps": {
          "applicant": "Applicant type",
          "insurance": "Insurance type",
          "details": "Contact details",
          "object": "Cover-specific details",
          "extra": "Additional information"
        },
        "applicant": {
          "title": "Who is applying for insurance?",
          "description": "This determines what we ask in the next steps.",
          "legend": "Applicant type",
          "individual_title": "Private individual",
          "individual_description": "Car, home, travel, health and other personal risks.",
          "company_title": "Legal entity",
          "company_description": "Company property, liability, employees and cargo."
        },
        "insurance": {
          "title": "What would you like to insure?",
          "description": "We only show types that match the applicant you selected. If none fit, choose “Other”.",
          "label": "Insurance type",
          "search": "Search insurance types…",
          "selected": "Selected: %{name}. In the next “cover-specific” step we will only ask what is needed to prepare an offer."
        },
        "details": {
          "individual_title": "Your contact details",
          "company_title": "Company information",
          "description": "We use this data only to prepare a quote and to contact you.",
          "first_name": "First name",
          "last_name": "Last name",
          "personal_code": "Personal code",
          "personal_code_hint": "Needed to prepare an accurate insurance quote.",
          "personal_code_placeholder": "123456-12345",
          "city": "City",
          "company_name": "Company name",
          "registration_number": "Registration number",
          "registration_placeholder": "40003000000",
          "contact_person": "Contact person",
          "employee_count": "Number of employees",
          "industry": "Industry",
          "industry_placeholder": "For example, construction or retail",
          "phone": "Phone",
          "phone_placeholder": "20000000",
          "email": "Email",
          "email_placeholder": "name@example.com"
        },
        "object": {
          "title": "Cover-specific information",
          "description_named": "These fields apply to %{name}. If you do not know something exactly, give an estimate — our consultant will confirm it.",
          "description": "If you do not know something exactly, give an estimate — our consultant will confirm it."
        },
        "extra": {
          "title": "Additional information",
          "description": "Tell us if anything is special — for example an existing policy, a preferred deductible or term.",
          "message": "Comments",
          "message_placeholder": "For example: current policy ends on 1 March, I want a lower deductible.",
          "consent_before": "I agree that my data is processed to prepare an insurance offer in accordance with the ",
          "consent_link": "privacy policy",
          "consent_after": ".",
          "marketing": "I would like to receive information about offers and policy renewal dates."
        }
      },
      "validation": {
        "applicant_type": "Select the applicant type",
        "insurance_type": "Select an insurance type",
        "insurance_type_available": "Select an available insurance type",
        "first_name": "Enter a first name",
        "first_name_short": "First name must be at least 2 characters",
        "last_name": "Enter a last name",
        "last_name_short": "Last name must be at least 2 characters",
        "personal_code": "Check the personal code",
        "city_short": "City name must be at least 2 characters",
        "company_name": "Enter the company name",
        "company_name_short": "Name must be at least 2 characters",
        "registration_number": "Enter the registration number",
        "contact_person": "Enter a contact person",
        "contact_person_short": "Contact person must be at least 2 characters",
        "employee_count": "Number of employees must be at least 1",
        "phone": "Enter a phone number",
        "phone_invalid": "Check the phone number (for example +37120000000)",
        "email": "Enter an email address",
        "email_invalid": "Check the email address",
        "field_required": "Enter: %{label}",
        "number": "Enter a number",
        "consent": "Consent to data processing is required"
      },
      "select": {
        "placeholder": "Select…",
        "search": "Search…",
        "no_results": "No results",
        "search_field": "Search: %{label}…"
      },
      "phone": {
        "country_code": "Country code",
        "countries": {
          "+371": "Latvia",
          "+372": "Estonia",
          "+370": "Lithuania",
          "+358": "Finland",
          "+46": "Sweden",
          "+47": "Norway",
          "+45": "Denmark",
          "+49": "Germany",
          "+48": "Poland",
          "+7": "Russia",
          "+1": "USA",
          "+44": "United Kingdom",
          "+33": "France",
          "+39": "Italy",
          "+34": "Spain"
        }
      },
      "breadcrumbs": {
        "location": "You are here"
      },
      "dates": {
        "locale": "en-GB",
        "year_suffix": ""
      }
    }
  }
}
